var $ = require("jquery");

// Mobile navigation
$("#js-menu__mobile-trigger").on("click", function() {
  $("#js-header").toggleClass("menu-mobile--active");
});

$("#js-header #block-dreist-main-menu .menu-item--expanded").on(
  "click",
  function() {
    $(this)
      .toggleClass("item-expanded")
      .removeClass("menu-item--expanded")
      .children('ul.menu').toggle();
  }
);

// Auch wenn, es git blame sagt, der Kram da unten ist nicht von mir !!!!

/* $(document).delegate(".js-toggle__trigger", "click", function(event) {
  event.preventDefault();
  $(".field--name-field-dd-product-image .field__item").each(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
  });
}); */

//Mobile init for accordion

$(document).on(
  "click",
  "#block-vertriebsmenu .menu-level--0 > li > a",
  function(event) {
    event.preventDefault();
  }
);

$(document).on(
  "click",
  "#block-vertriebsmenu .menu-level--1 > li > a",
  function(event) {
    event.stopImmediatePropagation();
  }
);

$(document).on("click", ".menu-item--expanded", function() {
  if ($(this).parents("nav#block-vertriebsmenu").length) {
    // Toggle function: menu items
    $(this)
      .next("ul.menu")
      .slideToggle(function() {
        $(this)
          .not(":visible")
          .css("display", "");
      })
      .end()
      .children("ul.menu")
      .slideToggle(function(event) {
        $(this)
          .children("li")
          .css("content", "-");
      })
      .click(function() {
        event.stopImmediatePropagation();
      });

    $(this).toggleClass("item-expanded");
  }
});

// Akkordion für Technische Daten

$(".toggleContent").each(function() {
  if ($(this).children().length > 4) {
    $(this)
      .find(".field:nth-child(5n)")
      .nextAll()
      .wrapAll('<div class="elemSlider" style="display: none">');
    let label = Drupal.t("Show all data");

    $(".toggleContent").append(
      `<div class="showDataBtn"><span>${
        label
      }</span><div class="icon icon-double_arrow_down"><svg role="img"><use xlink:href="#icon-double_arrow_down"></use></svg><span class="icon-click-target"></span></div></div>`
    );
  }
});

$(document).on("click", ".showDataBtn", function() {
  $(".elemSlider").slideToggle();

  let $self = $(this);
  $self.toggleClass("is-active");

  $self
    .children("span")
    .text(function(i, text) {
      return text === Drupal.t("Show all data")
        ? Drupal.t("Hide data")
        : Drupal.t("Show all data");
    })
    .end()
    .children("div")
    .text(function(i, text) {
      //return text === '&downarrow;' ? '&uparrow;' : "&downarrow;";
    });
});

// Parameter übergabe an Kontaktformularlinks

var pageUrl = window.location.search.substring(1);
var urlParams = pageUrl.split("?");

if (urlParams) {
  $(".contactform_class").each(function() {
    var elemUrl = $(this).attr("href") + "?" + urlParams;

    $(this).attr("href", elemUrl);
  });
}

// Suchseiten erweiterte Suche ausklappen
$(".search-form-wrapper details").attr("open", "");

$(".sidebar__trigger").click(function() {
  $(this).toggleClass("is-active");
  $(".sidebar").toggleClass("is-active");
});

if (!jQuery(".sidebar a:visible").length) {
  $(".sidebar__trigger").remove();
}
